import React, { useContext } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { NotificationContext } from '../../context/NotificationProvider';

const notificationVariants = {
  animate: { y: 0, opacity: 1, scale: 1 },
  exit: { y: -100, opacity: 0, scale: 0.3 },
};

const Notification = () => {
  const { notifications } = useContext(NotificationContext);
  return (
    <div className="absolute z-10 top-0 right-0">
      <ul>
        <AnimatePresence>
          {notifications.map((notification) => (
            <motion.li
              className="rounded shadow-md bg-red-200 border border-red-300 m-2 p-2"
              key={notification.id}
              layout
              initial="exit"
              animate="animate"
              exit="exit"
              variants={notificationVariants}
            >
              <p>
                <FontAwesomeIcon icon="exclamation-triangle" className="mr-2" />
                {notification.message}
              </p>
            </motion.li>
          ))}
        </AnimatePresence>
      </ul>
    </div>
  );
};

export default Notification;
